/* eslint-disable no-nested-ternary */
import React, { FC, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import { CircleCheckIcon, CircleInfoIcon, CircleWarningIcon, CrossIcon, TriangleErrorIcon } from '@shared/assets/icons';
import { toastPaddingsRem, toastPaddingsPx, toastTitleTextSizesDesktop, toastTitleTextSizesMobile, toastDescriptionTextSizesDesktop, toastDescriptionTextSizesMobile, toastBorderRadiusesRem, toastBorderRadiusesPx, toastSizes } from '@shared/config/components/toast';
import { Desktop, Mobile } from '@shared/lib/react';
import { Text } from '@shared/ui/atoms';
import { withTheme } from '@shared/lib/theme';
type SizeValue = keyof typeof toastSizes;
interface ToastProps extends ToastDataType {
  onDismiss: (id: string) => void;
}
const Toast: FC<ToastProps> = ({
  id,
  variant,
  size = 'l',
  title,
  description,
  duration,
  onDismiss
}) => {
  const [isExiting, setIsExiting] = useState(false);
  useEffect(() => {
    if (!duration) return;
    const timer = setTimeout(() => {
      handleToastClose();
    }, duration - 150);
    return () => {
      clearTimeout(timer);
    };
  }, [duration]);
  const getInfoIcon = () => {
    switch (variant) {
      case 'success':
        return <CircleCheckIcon />;
      case 'error':
        return <TriangleErrorIcon />;
      case 'warning':
        return <CircleWarningIcon />;
      case 'info':
        return <CircleInfoIcon />;
      default:
        return null;
    }
  };
  const handleToastClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      onDismiss(id);
    }, 150);
  };
  const desktopSize = typeof size === 'object' ? size.desktop || 'l' : size || 'l';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || 'l';
  return <ToastWrapper desktopSize={desktopSize} mobileSize={mobileSize} variant={variant} className={isExiting ? 'toast-exiting' : 'toast-entering'}>
      <InfoIconWrapper variant={variant}>{getInfoIcon()}</InfoIconWrapper>
      <TextWrapper>
        <Desktop>
          <Text family="MTSCompact" weight="medium" size={{
          desktop: toastTitleTextSizesDesktop[desktopSize],
          mobile: toastTitleTextSizesDesktop[mobileSize]
        }} color="primary">
            {title}
          </Text>
          <Text family="MTSCompact" weight="medium" size={{
          desktop: toastDescriptionTextSizesDesktop[desktopSize],
          mobile: toastDescriptionTextSizesDesktop[mobileSize]
        }} color="primary">
            {description}
          </Text>
        </Desktop>
        <Mobile>
          <Text family="MTSCompact" weight="medium" size={{
          desktop: toastTitleTextSizesMobile[desktopSize],
          mobile: toastTitleTextSizesMobile[mobileSize]
        }} color="primary">
            {title}
          </Text>
          <Text family="MTSCompact" weight="medium" size={{
          desktop: toastDescriptionTextSizesMobile[desktopSize],
          mobile: toastDescriptionTextSizesMobile[mobileSize]
        }} color="primary">
            {description}
          </Text>
        </Mobile>
      </TextWrapper>
      <CloseIconWrapper type="button" onClick={handleToastClose}>
        <CrossIcon />
      </CloseIconWrapper>
    </ToastWrapper>;
};
export default Toast;
type ToastWrapperProps = Required<Pick<ToastDataType, 'variant'>> & {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
};
const _exp = /*#__PURE__*/() => ({
  desktopSize
}) => toastPaddingsRem[desktopSize];
const _exp2 = /*#__PURE__*/() => ({
  desktopSize
}) => toastBorderRadiusesRem[desktopSize];
const _exp3 = /*#__PURE__*/() => ({
  variant,
  theme
}) => theme.colors.toast[variant]?.background;
const _exp4 = /*#__PURE__*/() => ({
  mobileSize
}) => toastPaddingsPx[mobileSize];
const _exp5 = /*#__PURE__*/() => ({
  mobileSize
}) => toastBorderRadiusesPx[mobileSize];
const ToastWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "ToastWrapper",
  class: "t9yu67b",
  propsAsIs: false,
  vars: {
    "t9yu67b-0": [_exp()],
    "t9yu67b-1": [_exp2()],
    "t9yu67b-2": [_exp3()],
    "t9yu67b-3": [_exp4()],
    "t9yu67b-4": [_exp5()]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  variant,
  theme
}) => theme.colors.toast[variant]?.icon;
const InfoIconWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "InfoIconWrapper",
  class: "i11wgs2k",
  propsAsIs: false,
  vars: {
    "i11wgs2k-0": [_exp6()]
  }
}));
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t177n66h",
  propsAsIs: false
});
const CloseIconWrapper = /*#__PURE__*/styled('button')({
  name: "CloseIconWrapper",
  class: "c1pr58ua",
  propsAsIs: false
});

require("./Toast.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Toast.tsx");